import { Button, Modal, ModalBody, ModalFooter } from '@7shifts/sous-chef';
import { User } from 'adminPanel/types';

type Props = {
    user: User;
    onClose: () => void;
};

const UserQueuesModal = ({ user, onClose }: Props) => {
    const queues = user.queues ?? [];

    return (
        <Modal header={`Filas de ${user.name}`} onClose={onClose}>
            <ModalBody>
                {queues.length === 0 ? (
                    <p style={{ color: '#868e96', margin: 0 }}>
                        Este usuário não está vinculado a nenhuma fila.
                    </p>
                ) : (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8
                        }}
                    >
                        {queues.map((queue) => (
                            <div
                                key={queue.id}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                    padding: '8px 12px',
                                    background: '#f8f9fa',
                                    border: '1px solid #e9ecef',
                                    borderRadius: 6
                                }}
                            >
                                <span
                                    style={{
                                        width: 12,
                                        height: 12,
                                        borderRadius: '50%',
                                        background: queue.color || '#adb5bd',
                                        flexShrink: 0
                                    }}
                                />
                                <span style={{ fontSize: 14 }}>
                                    {queue.name}
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </ModalBody>
            <ModalFooter
                actions={{
                    primary: (
                        <Button theme="hollow" onClick={onClose}>
                            Fechar
                        </Button>
                    )
                }}
            />
        </Modal>
    );
};

export default UserQueuesModal;
